import { render, staticRenderFns } from "./DomobIcon.vue?vue&type=template&id=e9e031e2&"
import script from "./DomobIcon.vue?vue&type=script&lang=js&"
export * from "./DomobIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports